import React from 'react'

import { ScenarioRun } from 'api'
import useAgent from 'hooks/use-agent'
import useAuth from 'hooks/use-auth'
import { naturalSortBy } from 'utils/list'

// this component wraps the `ActiveScenarioListItem` to provide it with the latest run
// so that component can remain simple and easily testable
export const LatestScenarioRunProvider: React.FC<{
  scenarioId: string
  interval?: number
  children(
    run: ScenarioRun,
    isLoading: boolean,
    hasError: boolean
  ): React.ReactNode
}> = ({ scenarioId, children = () => null, interval = 10_000 }) => {
  const { currentTeamId } = useAuth()
  const {
    data: runs,
    isLoading,
    hasError
  } = useAgent(`/scenarios/${scenarioId}/runs?teamId=${currentTeamId}`, [], {
    shouldCache: true,
    interval
  })

  if (isLoading || hasError) {
    return children(null, isLoading, hasError)
  }

  const sortedRuns = naturalSortBy(runs, (r) => r.created_at, 'desc')

  return children(sortedRuns[0], isLoading, hasError)
}
